// extracted by mini-css-extract-plugin
export default {"coinsWrapper":"UserBalance_coinsWrapper__80upy","coinsWrapper_small":"UserBalance_coinsWrapper_small__G+tR7","currencyIcon":"UserBalance_currencyIcon__YU3Kh"};